'use client';

import { SidebarProvider, SidebarInset } from '../ui/sidebar';
import { SiteHeader } from './site-header.js';
import { SiteSidebar } from './site-sidebar.js';
import { useNavigation } from '../../hooks/use-navigation.js';
import { Outlet } from 'react-router-dom';  // import Outlet
import illustrator from "../../assets//illustrator/illus-background-2.png"
import { useTheme } from '../themeProvider';
import CopilotLauncher from '../copilot/CopilotLauncher';

export function AppLayout() {
  const { dynamicNav } = useNavigation();
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <SidebarProvider>
      <SiteSidebar menuItems={dynamicNav} />
      <SidebarInset>
        <SiteHeader menuItems={dynamicNav} />
        <main
          className="flex-1 p-2 md:p-3 lg:p-3 bg-cover bg-no-repeat"
          style={{
            backgroundImage: !isDark ? `url(${illustrator})` : "none",
            backgroundPosition: "top right",
          }}
        >
          <Outlet />
        </main>
        {/* App-wide AI Copilot. Hides itself on /ai/copilot so the full-page
            workspace isn't shadowed by the docked panel. */}
        <CopilotLauncher />
      </SidebarInset>
    </SidebarProvider>
  );
}